import { Navigate, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/docs/portal/")({
	component: () => <Navigate to="/docs/portal/endpoints" />,
});
